import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { EconomicDevelopmentMapItem } from '../../definitions/economic-development-map-item';
import { MapItemComponent } from '@ui/shared/util-map';

import { DetailViewModule } from '@ui/shared/ui-detail-view';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-economic-development-map-item-popup-content',
    templateUrl: './economic-development-map-item-popup-content.component.html',
    styleUrls: ['./economic-development-map-item-popup-content.component.scss'],
    imports: [
        DetailViewModule,
    ],
})
export class EconomicDevelopmentMapItemPopupContentComponent
    implements MapItemComponent<EconomicDevelopmentMapItem> {
    public mapItem = input<EconomicDevelopmentMapItem>();
}
